
export default {
    component : ()=>import('@/modules/user/layouts/UserLayout'),
    children: [
        {
            path:'/alumno',
            name:'alumno-inicio',
            component:()=>import('@/modules/user/views/AlumnoPanelView.vue')
        },
        {
            path:'/alumno/examen-titulacion-presencial',
            name:'examen-titulacion-presencial',
            component:()=>import('@/modules/user/views/DatosExamenPresencialView.vue')
        },
        {
            path:'/alumno/examen-titulacion-en-linea',
            name:'examen-titulacion-en-linea',
            component:()=>import('@/modules/user/views/DatosExamenEnLineaView.vue')
        },
        {
            path:'/alumno/registro-examen-presencial',
            name:'registro-examen-presencial',
            component:()=>import('@/modules/user/views/RegistroExamenPresencialView.vue')
        },
        {
            path:'/alumno/registro-examen-en-linea',
            name:'registro-examen-en-linea',
            component:()=>import('@/modules/user/views/RegistroExamenEnLineaView.vue')
        },
        {
            path:'/alumno/cursos-talleres-grupos',
            name:'cursos-grupos',
            component:()=>import('@/modules/user/views/HorariosGruposView.vue')
        },
        {
            path:'/alumno/cursos-talleres-inscripciones',
            name:'cursos-registros',
            component:()=>import('@/modules/user/views/RegistrosGruposView.vue')
        },
        {
            path: '/alumno/perfil',
            name: 'alumno-perfil',
            component: () => import('@/modules/user/views/AlumnoPerfilView.vue')
        },
        {
            path:'/alumno/examen-posgrado-presencial',
            name:'examen-posgrado-presencial',
            component:()=>import('@/modules/user/views/DatosExamenPosgradoPresencialView.vue')
        },
        {
            path:'/alumno/registro-examen-posgrado-presencial',
            name:'registro-examen-posgrado-presencial',
            component:()=>import('@/modules/user/views/RegistroExamenPosgradoPresencialView.vue')
        },
        // {
        //     path:'/alumno/registro-examen-posgrado-en-linea',
        //     name:'registro-examen-posgrado-en-linea',
        //     component:()=>import('@/modules/user/views/RegistroExamenPosgradoEnLineaView.vue')
        // }       
    ]
}